import { render, staticRenderFns } from "./upload-certificate-dfr-3.vue?vue&type=template&id=74582be0&"
import script from "./upload-certificate-dfr-3.vue?vue&type=script&lang=js&"
export * from "./upload-certificate-dfr-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports